import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";
import LoginModal from "./LoginModal";

const Layout = ({ children }) => {
  const { token, user, logout, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  // Capture OAuth token from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const oauthToken = params.get("token");
    if (oauthToken) {
      login(oauthToken);
      // Clear the token from URL to avoid clutter
      navigate(location.pathname, { replace: true });
      // Ensure modal is closed if we just logged in
      setIsLoginModalOpen(false);
    }
  }, [location, login, navigate]);

  const openLogin = (e) => {
    e.preventDefault();
    setIsLoginModalOpen(true);
  };

  const closeLogin = () => setIsLoginModalOpen(false);

  return (
    <div className="layout">
      <header className="app-header">
        <Link to="/" className="brand">
          Financial Insights
        </Link>
        <div className="nav-right">
          {token ? (
            <>
              <span className="user-greeting">Welcome, {user?.sub || "User"}!</span>
              <button className="button-outline" onClick={logout}>
                Logout
              </button>
            </>
          ) : (
            <button className="button" onClick={openLogin}>
              Login
            </button>
          )}
        </div>
      </header>
      <main className="main-content">{children}</main>

      <LoginModal isOpen={isLoginModalOpen} onClose={closeLogin} />
    </div>
  );
};

export default Layout;
